import { RSAA } from "redux-api-middleware";

import config from "@/utils/config";

import { PARTS_FAILURE, PARTS_REQUEST, PARTS_SAVE_QUERY, PARTS_SUCCESS } from "./types";

export const loadParts = (id: string, page: string | number = "1") => ({
  [RSAA]: {
    endpoint: `${config.get("apiSuzuki")}item-price/${id}/?page=${page}`,
    method: "GET",
    types: [PARTS_REQUEST, PARTS_SUCCESS, PARTS_FAILURE],
  },
});

export type LoadPartsType = typeof loadParts;

export const saveQuery = (query: string) => {
  return {
    type: PARTS_SAVE_QUERY,
    payload: query,
  };
};

export type SaveQueryType = typeof saveQuery;
